import React from 'react';
import { Plus } from 'lucide-react';

export const IdentityLocker: React.FC = () => {
    return (
        <div className="space-y-2">
            <h3 className="text-xs font-medium text-gray-400 uppercase tracking-wider">Identity Locker</h3>
            <div className="bg-gray-800 p-4 rounded-lg space-y-4">
                <div className="grid grid-cols-5 gap-2">
                    {[1, 2, 3, 4, 5].map((i) => (
                        <div key={i} className="aspect-square bg-gray-700 rounded flex items-center justify-center hover:bg-gray-600 cursor-pointer transition-colors group">
                            <Plus size={16} className="text-gray-500 group-hover:text-white" />
                        </div>
                    ))}
                </div>
                <p className="text-[10px] text-gray-500">Upload specific models to force them into the scene.</p>
            </div>
        </div>
    );
};
